<template>
    <div>
        <div v-if="isLoading" class="loader-overlay">
          <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        <div class="container-fluid">
            <div class="llp-container-section heightcontainer">
                <top-header id="height2"></top-header>
                <main-menu id="height3"></main-menu>
                <div class="menu-margin-top">
                    <div class="row px-3 ml-0 ">
                        <div class="col-lg-5 col-sm-12 mt-3">
                            <h3 class="mb-0">MMR</h3>
                            <small class="data-availability-text">Data availability: {{dataDateRange}}</small>
                        </div>
                        <div class="col-lg-3 row ">
                        <div class="col-lg-12 col-sm-12 activitySearch mt-3">
                            <div class="search-input-wrapper">
                                <input 
                                    class="form-control search-input" 
                                    type="text" 
                                    placeholder="Search by vin/loan id" 
                                    v-model="mmrListSearch"
                                    @keyup.enter="searchMmrList()"
                                >
                                <button 
                                    v-if="mmrListSearch" 
                                    type="button" 
                                    class="clear-search-btn" 
                                    @click="clearMmrListSearch"
                                    aria-label="Clear search"
                                >
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="currentColor"/>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <!-- <div class="col-lg-3 col-sm-12 activitySearch mt-3">
                            <select id="preferredccdd"
                          class="form-control" 
                          v-model="selectedYear"
                          @change="onYearMonthChange"
                          >
                        <option value="" selected>Select Year</option>
                        <option v-for="year in years" :value="year">{{ year }}</option>
                      </select>
                        </div> -->
                        <!-- <div class="col-lg-3 col-sm-12 activitySearch mt-3">
                            <select id="preferredccdd"
                          class="form-control"
                          v-model="selectedMonth"   
                          @change="onYearMonthChange"
                          >
                        <option value="" selected>Select Month</option>
                        <option v-for="month in months" :value="month.value">{{ month.month }}</option>
                      </select>
                        </div> -->
                        <!-- <div class="col-lg-3 col-sm-12 activitySearch mt-3">
                            <select id="preferredccdd"
                          class="form-control"
                          v-model="exportType"
                          @change="onExportTypeChange()"
                          >
                        <option value="" disabled hidden>Export</option>
                        <option value="type1">
                            LoanPro Upload File
                        </option>
                        <option value="type2">Current Month MMR Report</option>
                        <option value="type3">Historical VIN Data</option>
                      </select>
                        </div> -->
                        
                    </div>
                    <div class="col-lg-4 col-sm-12 activitySearch mt-3 tableFilterAction align-items-baseline">
                            <b-dropdown 
                                ref="filterDropdown"
                                id="filter-dropdown" 
                                :text="'Filter'" 
                                variant="outline-secondary"
                                class="filter-btn-dropdown"
                                right
                                no-caret
                            >
                                <!-- <template #button-content>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3 17V19H9V17H3ZM3 5V7H13V5H3ZM13 21V19H21V17H13V15H11V21H13ZM7 9V11H3V13H7V15H9V9H7ZM21 13V11H11V13H21ZM15 9H17V11H21V13H17V15H15V9ZM3 13V11H9V13H3Z" fill="currentColor"/>
                                    </svg>
                                </template> -->
                                <div class="comm-dropdown filterMenuOuter">
                                    <div class="form-wrap">
                                        <div class="d-flex filter-header mb-20">
                                            <h3 class="flex-grow-1">Filter by</h3>
                                            <button 
                                                type="button"
                                                class="btn-link p-0 close-btn" 
                                                @click.stop="closeFilterMenu"
                                                aria-label="Close"
                                            >
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="currentColor"/>
                                                </svg>
                                            </button>
                                        </div>

                                        <div class="form-row">
                                            <div class="inputBox">
                                                <label class="form-label">Date</label>
                                                <div class="dateRangeBox d-flex gap-4">
                                                    <div class="date-input-wrapper" style="flex: 1;">
                                                        <input 
                                                            type="date" 
                                                            class="form-control" 
                                                            v-model="filterStartDate"
                                                            placeholder="Start Date"
                                                            :max="filterEndDate || new Date().toISOString().split('T')[0]"
                                                            @change="customDateChange"
                                                        >
                                                    </div>
                                                    <div class="date-input-wrapper" style="flex: 1;">
                                                        <input 
                                                            type="date" 
                                                            class="form-control" 
                                                            v-model="filterEndDate"
                                                            placeholder="End Date"
                                                            :min="filterStartDate"
                                                            :max="new Date().toISOString().split('T')[0]"
                                                            @change="customDateChange"
                                                        >
                                                    </div>
                                                </div>
                                                <div class="or-divider">
                                                    <span class="or-text">OR</span>
                                                </div>
                                                <div class="yearMonthBox d-flex gap-4 mt-3">
                                                    <div class="select-wrapper" style="flex: 1;">
                                                        <select 
                                                            class="form-control" 
                                                            v-model="selectedYear"
                                                            @change="onYearMonthChange"
                                                        >
                                                            <option value="">Select Year</option>
                                                            <option v-for="year in years" :value="year">{{ year }}</option>
                                                        </select>
                                                    </div>
                                                    <div class="select-wrapper" style="flex: 1;">
                                                        <select 
                                                            class="form-control" 
                                                            v-model="selectedMonth"
                                                            @change="onYearMonthChange"
                                                        >
                                                            <option value="">Select Month</option>
                                                            <option v-for="month in months" :value="month.value">{{ month.month }}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="form-row">
                                            <div class="inputBox">
                                                <div class="selectBox d-flex gap-4">
                                                    <div class="select-wrapper" style="flex: 1;">
                                                        <label class="form-label">Vin</label>
                                                        <multiselect style="width:100%" v-model="filterVin" :options="vinOptions"
                                                        :value="vinOptions" placeholder="Select Vin ID" 
                                                        selected="selected" id="vinIddd">
                                                        </multiselect>
                                                        <!-- <select class="form-control" v-model="filterVin">
                                                            <option value="">Select Vin</option>
                                                            <option v-for="(vinOption, index) in vinOptions" :key="index" :value="vinOption">
                                                                {{ vinOption }}
                                                            </option>
                                                        </select> -->
                                                    </div>
                                                    <div class="select-wrapper" style="flex: 1;">
                                                        <label class="form-label">Loan ID</label>
                                                        <multiselect style="width:100%" v-model="filterLoanId" :options="loanIdOptions"
                                                        :value="loanIdOptions" placeholder="Select Loan ID" 
                                                        selected="selected" id="loanIddd">
                                                        </multiselect>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-row">
                                            <div class="inputBox">
                                                <div class="selectBox d-flex gap-4">
                                                    <div class="select-wrapper" style="flex: 1;">
                                                        <label class="form-label">Report Type</label>
                                                        <!-- <multiselect style="width:100%" v-model="filterReportType" :options="reportTypeOptions"
                                                        :value="reportTypeOptions" placeholder="Select Report Type" 
                                                        selected="selected" id="reportTypeIddd">
                                                        </multiselect> -->
                                                        <select 
                                                            class="form-control" 
                                                            v-model="filterReportType"
                                                        >
                                                            <option value="">Select Report Type</option>
                                                            <option v-for="reportType in reportTypeOptions" :value="reportType.value">{{ reportType.name }}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="filterBtnHolder">
                                            <!-- <button 
                                                type="button"
                                                class="btn btn-outline-primary" 
                                                @click.stop="resetFilter"
                                                :disabled="filterStartDate === '' && filterEndDate === '' && selectedYear === '' && selectedMonth === '' && filterVin === '' && filterLoanId == ''"
                                                :class="{ 'disabled-btn': filterStartDate === '' && filterEndDate === '' && selectedYear === '' && selectedMonth === '' && filterVin == '' && filterLoanId === '' }"
                                            >
                                                Reset
                                            </button> -->
                                            <button 
                                                type="button"
                                                class="btn btn-primary" 
                                                @click.stop="applyFilter"
                                                :disabled="filterStartDate === '' && filterEndDate === '' && selectedYear === '' && selectedMonth === '' && filterVin === '' && filterLoanId === ''"
                                                :class="{ 'disabled-btn': filterStartDate === '' && filterEndDate === '' && selectedYear === '' && selectedMonth === '' && filterVin === '' && filterLoanId === '' }"
                                            >
                                                Apply Filter
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </b-dropdown>
                            <button 
                                                type="button"
                                                class="btn filter-btn-dropdown exportBtn ml-2" 
                                                @click.stop="resetFilter"
                                                :disabled="filterStartDate === '' && filterEndDate === '' && selectedYear === '' && selectedMonth === '' && filterVin === '' && filterLoanId == ''"
                                                :class="{ 'disabled-btn': filterStartDate === '' && filterEndDate === '' && selectedYear === '' && selectedMonth === '' && filterVin == '' && filterLoanId === '' }"
                                            >
                                                Reset
                                            </button>
                                            <button v-if="!isCheckStatus"
                                                type="button"
                                                class="btn filter-btn-dropdown exportBtn ml-2" 
                                                @click="executeScript()"
                                            >
                                                Execute Script
                                            </button>
                                            <button v-if="isCheckStatus"
                                                type="button"
                                                class="btn filter-btn-dropdown exportBtn ml-2" 
                                                @click="checkStatus()"
                                            >
                                                Check Status
                                            </button>
                        </div>
                        
                    </div>
                    <div class="row px-3 justify-content-center mt-3">
                        <div class="col-12 text-center d-flex justify-content-center gap-4 align-items-center flex-wrap">
                            <button class="exportBtn" @click="onExportTypeChange('type1')">Export loan pro upload file</button>
                            <button class="exportBtn" @click="onExportTypeChange('type2')">Export current month MMR report</button>
                            <template v-if="!showHistoricalExportDateRange">
                                <button class="exportBtn" @click="showHistoricalExportDateRange = true">Export historical VIN data</button>
                            </template>
                            <template v-else>
                                <div class="d-flex gap-3 align-items-center historical-export-date-range">
                                    <div class="date-input-wrapper mr-2">
                                        <input 
                                            type="date" 
                                            class="form-control" 
                                            v-model="exportStartDate"
                                            placeholder="Start Date"
                                            :max="exportEndDate || new Date().toISOString().split('T')[0]"
                                        >
                                    </div>
                                    <div class="date-input-wrapper mr-2">
                                        <input 
                                            type="date" 
                                            class="form-control" 
                                            v-model="exportEndDate"
                                            placeholder="End Date"
                                            :min="exportStartDate"
                                            :max="new Date().toISOString().split('T')[0]"
                                        >
                                    </div>
                                    <button class="exportBtn" @click="exportHistoricalVinData()">Export</button>
                                    <button class="exportBtn cancelBtn" @click="cancelHistoricalExport()">Cancel</button>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="row tableContainer pb-4 px-3 ml-0 mt-5 ">
                      <div v-if="errorMessage !== ''" class="col-12 font-weight-bold text-danger text-center" role="alert">{{errorMessage}}</div>
                      <div v-if="successMessage !== ''" class="col-12 font-weight-bold text-success text-center" role="alert">{{successMessage}}</div>
                      <div class="col-12">
                        <div class="d-flex justify-content-between align-items-center mt-4 mb-3">
                          <div class="total-records-text">
                            <strong>{{ recordRange }}</strong>
                          </div>
                        </div>
                        <table class="table table-responsive mt-2 customerTable">
                          <thead class="tableHeading">
                            <tr>
                              <th style="width:5%">S.No.</th>
                              <th style="width:20%">Loan ID</th>
                              <th style="width:25%">Vin</th>
                              <th style="width:15%">Year</th>
                              <th style="width:20%">Make</th>
                              <th style="width:20%">Model</th>
                              <th style="width:20%">Trim</th>
                              <th style="width:20%">Requested Date</th>
                              <th style="width:20%">Adj Wholesale Average</th>
                              <th style="width:20%">Wholesale Average</th>
                              <th style="width:15%">Odometer(miles)</th>
                              <th style="width:15%">Average Odometer</th>
                              <th style="width:5%">Details</th>
                            </tr>
                          </thead>
                          <template>
                          <tbody v-if="mmrListData.length>0">
                            <template v-for="(mmr, index) in mmrListData" >
                              <tr>
                                <td class="tableMobile align-middle">{{ (currentPage - 1) * perPage + index + 1 }}</td>
                                <td class="tableCustomerId align-middle">
                                  <div class="d-flex align-items-center" style="gap: 8px;">
                                    <span v-if="mmr.multiVariant"
                                      class="expand-arrow" 
                                      :class="{ 'expanded': isRowExpanded(getRowKey(mmr, index)) }"
                                      @click="toggleRowExpansion(getRowKey(mmr, index),mmr)"
                                      style="cursor: pointer; user-select: none;"
                                    >
                                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6 4L10 8L6 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                    </span>
                                    <span>{{mmr.loanId}}</span>
                                  </div>
                                </td>
                                <td class="tableName align-middle" :class="{ 'text-warning': mmr.multiVariant && !mmr.correctVariant }">{{mmr.vin}}</td>
                                <td class="tableEmail align-middle">{{mmr.year}}</td>
                                <td class="tableMobile align-middle">{{mmr.make}}</td>
                                <td class="tableMobile align-middle">{{mmr.model}}</td>
                                <td class="tableMobile align-middle">{{mmr.trim}}</td>
                                <td class="tableMobile align-middle">{{mmr.requestedDate}}</td>
                                <td class="tableMobile align-middle">{{formatNumberInternational(mmr.adjWholesaleAverage)}}</td>
                                <td class="tableMobile align-middle">{{formatNumberInternational(mmr.wholesaleAverage)}}</td>
                                <td class="tableMobile align-middle">{{mmr.odometer }}</td>
                                <td class="tableMobile align-middle">{{mmr.averageOdometer}}</td>
                                <td class="tableMobile align-middle"><img src="@/assets/info.png" style="cursor: pointer;" alt="view" class="" @click="openExportDrawer(mmr.vin)"></td>
                              </tr>
                              <tr v-if="isRowExpanded(getRowKey(mmr, index))" :key="'expanded-' + getRowKey(mmr, index)" class="expanded-row">
                                <td colspan="13" class="expanded-content">
                                  <div class="expanded-content-wrapper">
                                    <div class="expanded-table-container">
                                      <table class="table table-responsive expanded-table">
                                        <thead>
                                          <tr>
                                            <th>Action</th>
                                            <th>Vin</th>
                                            <th>Year</th>
                                            <th>Make</th>
                                            <th>Model</th>
                                            <th>Trim</th>
                                            <th>Requested Date</th>
                                            <th>Adj Wholesale Average</th>
                                            <th>Wholesale Average</th>
                                            <th>Odometer(miles)</th>
                                            <th>Average Odometer</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr 
                                            v-for="(variant, variantIndex) in multiVariantData[getRowKey(mmr, index)] || []" 
                                            :key="variant.id || variantIndex"
                                          >
                                            <td>
                                              <input 
                                                type="radio" 
                                                :name="'variant-' + getRowKey(mmr, index)" 
                                                :value="variant.id" 
                                                :checked="selectedVariant[getRowKey(mmr, index)] === variant.id"
                                                @mousedown.prevent="showVariantConfirmModal(variant.id, mmr.loanId, getRowKey(mmr, index), variant, $event)"
                                                @click.prevent
                                              >
                                            </td>
                                            <td>{{ variant.vin }}</td>
                                            <td>{{ variant.year }}</td>
                                            <td>{{ variant.make }}</td>
                                            <td>{{ variant.model }}</td>
                                            <td>{{ variant.trim }}</td>
                                            <td>{{ variant.requestedDate }}</td>
                                            <td>{{ formatNumberInternational(variant.adjWholesaleAverage) }}</td>
                                            <td>{{ formatNumberInternational(variant.wholesaleAverage) }}</td>
                                            <td>{{ variant.odometer }}</td>
                                            <td>{{ variant.averageOdometer }}</td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                    <!-- <div class="expanded-controls">
                                      <div class="radio-buttons-group">
                                        <div class="form-check">
                                          <input 
                                            class="form-check-input" 
                                            type="radio" 
                                            :name="'radio-' + getRowKey(mmr, index)" 
                                            :id="'option1-' + getRowKey(mmr, index)"
                                            :value="'option1'"
                                            v-model="selectedRadioOption[getRowKey(mmr, index)]"
                                          >
                                          <label class="form-check-label" :for="'option1-' + getRowKey(mmr, index)">
                                            Option 1
                                          </label>
                                        </div>
                                        <div class="form-check">
                                          <input 
                                            class="form-check-input" 
                                            type="radio" 
                                            :name="'radio-' + getRowKey(mmr, index)" 
                                            :id="'option2-' + getRowKey(mmr, index)"
                                            :value="'option2'"
                                            v-model="selectedRadioOption[getRowKey(mmr, index)]"
                                          >
                                          <label class="form-check-label" :for="'option2-' + getRowKey(mmr, index)">
                                            Option 2
                                          </label>
                                        </div>
                                        <div class="form-check">
                                          <input 
                                            class="form-check-input" 
                                            type="radio" 
                                            :name="'radio-' + getRowKey(mmr, index)" 
                                            :id="'option3-' + getRowKey(mmr, index)"
                                            :value="'option3'"
                                            v-model="selectedRadioOption[getRowKey(mmr, index)]"
                                          >
                                          <label class="form-check-label" :for="'option3-' + getRowKey(mmr, index)">
                                            Option 3
                                          </label>
                                        </div>
                                      </div>
                                      <button 
                                        type="button" 
                                        class="btn btn-primary expanded-action-btn"
                                        @click="handleExpandedAction(mmr, getRowKey(mmr, index))"
                                      >
                                        Action Button
                                      </button>
                                    </div> -->
                                  </div>
                                </td>
                              </tr>
                            </template>
                          </tbody>
                          <tbody v-else class="text-center">
                            <tr><td colspan="12">{{noResult}}</td></tr>
                          </tbody>
                          </template>
                        </table>
                      </div>
                    </div>
                </div>
                <div class="mt-5 mb-5 pb-3">
                        <b-pagination align="center" v-if="rows>perPage && mmrListData.length>0"
                         v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        first-number
                        last-number
                        @input="pagination"
                        class="customPagination"
                        ></b-pagination>
                </div>
                <!--confirm variant selection modal-->
        <div @click.self="isVariantConfirm = false" v-if="isVariantConfirm" class="modal" id="variantConfirmModal">
          <div class="modal-content">
            <div class="modal-heading">
              <h4>Confirm Variant Selection</h4>
            </div>
            <div class="modal-body">
              <img src="../assets/question.jpg" alt="" class="logo mt-2" />
              <p class="modalText mt-3 mb-4">
                Are you sure, Do you want to mark this variant as correct?
              </p>
              <div class="d-flex justify-content-center mt-2 mb-1">
                <button
                  type="button"
                  class="btn mergeButton mx-2"
                  @click="confirmVariantSelection()"
                >
                  Confirm
                </button>
                <button type="button" @click="cancelVariantSelection()" class="btn yesButton mx-2">Cancel</button>
              </div>
            </div>
          </div>
        </div>
        <!--confirm variant selection modal end-->
        <!--successful merge dialog code start-->
         <div v-if="isExportSuccess" class="modal" id="exportSuccessModal" @click.self="closeExportSuccess()">
          <div class="modal-content">
            <div class="modal-body">
              <img src="../assets/checkicon-min.png" alt="" class="logo" v-if="exportSuccess" />
              <img src="../assets/error.png" alt="" class="logo" v-else />
              <p class="modalText">
              {{exportSuccess || exportError}}
              </p>
            </div>
          </div>
        </div>
        <!--successful merge dialog code end-->
                <bottom-footer></bottom-footer>
            </div>
        </div>

        <!-- MMR Export Drawer -->
        <div class="mmrExportDrawerWrapper" :class="{ 'drawer-open': isDrawerOpen }">
            <!-- Backdrop -->
            <div 
                v-if="isDrawerOpen" 
                class="drawer-backdrop" 
                @click="closeExportDrawer"
            ></div>
            
            <!-- Drawer -->
            <div class="mmrExportDrawer" :class="{ 'drawer-open': isDrawerOpen }">
                <div class="drawer-header d-flex justify-content-between align-items-center">
                    <h2>MMR</h2>
                    <button 
                        type="button" 
                        class="btn  p-0" 
                        aria-label="Close" 
                        @click="closeExportDrawer"
                        style="border: none; background: none; cursor: pointer;"
                    >
                        <span style="font-size: 24px;">&times;</span>
                    </button>
                </div>
                
                <div class="vehicleInfo">
                    <div class="headerData d-flex justify-content-between">
                        <div class="leftData">
                            <h3>{{ singleVinMmrData[0] ? singleVinMmrData[0].make : '' }} {{ singleVinMmrData[0] ? singleVinMmrData[0].model : '' }}</h3>
                            <div class="metaInfoFlexItem d-flex gap-4">
                                <p>LEASE ID: <strong>{{ singleVinMmrData[0] ? singleVinMmrData[0].loanId : '' }}</strong></p>
                                <p>VIN ID: <strong>{{ selectedVinNumber }}</strong></p>
                            </div>
                        </div>
                        <div class="rightData">
                            <button 
                                type="button"
                                class="btn btn-link" 
                                @click="getMmrReportForVinDetail(selectedVinNumber, 'type3')"
                            >
                                <img src="@/assets/csv-download.png" alt="export" >
                            </button>
                        </div>
                    </div>

                    <div class="exportCalendar">
                        <div class="commonFomrWrapper">
                            <div class="row form-row mt-4">
                                <div class="col-md-6 col-12">
                                    <div class="form-group">
                                        <label class="form-label">Year</label>
                                        <select 
                                            class="form-control" 
                                            v-model="selectedYearForVinDetail"
                                            @change="onDrawerYearMonthChange(selectedVinNumber)"
                                        >
                                            <option value="">Select</option>
                                            <option v-for="year in years" :value="year">{{ year }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6 col-12">
                                    <div class="form-group">
                                        <label class="form-label">Month</label>
                                        <select 
                                            class="form-control" 
                                            v-model="selectedMonthForVinDetail"
                                            @change="onDrawerYearMonthChange(selectedVinNumber)"
                                        >
                                            <option value="">Select</option>
                                            <option v-for="month in months" :value="month.value">{{ month.month }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="drawer-content">
                    <div class="timeline">
                        <div class="timelineItems">
                            <div 
                                class="timelineItem" 
                                v-for="(entry, index) in singleVinMmrData" 
                                :key="index"
                            >
                                <div class="timelineMarker"></div>
                                <div class="timelineContent">
                                    <div class="timelineHeader">
                                        <span class="timelineDate">{{ formateRequestedDate(entry.requestedDate) }}</span>
                                        <div class="timelineValueWrapper">
                                            <span class="timelineValueLabel">Adj wholesale average</span>
                                            <span class="timelineValue">{{ formatNumberInternational(entry.adjWholesaleAverage) }}</span>
                                        </div>
                                    </div>
                                    <p class="timelineValueLabel">Odometer miles: {{ entry.odometer }} {{ entry.odometerUnits }}</p>
                                </div>
                            </div>
                        </div>
                        <div v-if="singleVinMmrData.length===0" class="text-center">
                            <p>{{ noResult }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </template>
    <script>
    import TopHeader from "@/components/TopHeader.vue";
    import MainMenu from "@/components/Menu.vue";
    import BottomFooter from "@/components/BottomFooter.vue";
    import httpcommon from "../js/http-common.js";
    import moment from 'moment';
    
    export default {
      components: {
        MainMenu,
        TopHeader,
        BottomFooter,
      },
      name: "customerActivityLog",
    
      data() {
      return {
        mmrListData: [],
        noResult: '',
        isLoading: false,
        rows: 0,
        currentPage: 1,
        perPage: 10,
        activitySearch: '',
        mmrListSearch: '',
        isMmrListSearch: false,
        isSearch: false,
        exportType: '',
        isDrawerOpen: false,
        selectedYear: new Date().getFullYear(),
        selectedMonth: new Date().getMonth() + 1,
        selectedYearForVinDetail: '',
        selectedMonthForVinDetail: '',
        singleVinMmrData: [],
        startDate: '',
        endDate: '',
        vin: '',
        loanId: '',
        dataDateRange: '',  
        isExportSuccess: false,
        exportSuccess: '',
        exportError: '',
        months: [{month: 'January',value:1}, {month: 'February',value:2}, {month: 'March',value:3}, {month: 'April',value:4}, {month: 'May',value:5}, {month: 'June',value:6}, {month: 'July',value:7}, {month: 'August',value:8}, {month: 'September',value:9}, {month: 'October',value:10}, {month: 'November',value:11}, {month: 'December',value:12}],
        years: [],
        filterStartDate: '',
        filterEndDate: '',
        filterVin: '',
        filterLoanId: '',
        filterReportType: '',
        reportTypeOptions: [
          { name: 'All', value: 'all' },
          { name: 'Multivariant', value: 'multi_variant' },
          { name: 'Single Variant', value: 'single_variant' },
        ],
        showHistoricalExportDateRange: false,
        exportStartDate: '',
        exportEndDate: '',
        vinOptions: [],
        loanIdOptions: [],
        selectedVinNumber: '',
        expandedRows: [],
        selectedRadioOption: {},
         multiVariantData: {},
         selectedVariant: {},
         isVariantConfirm: false,
         pendingVariantSelection: {
           variantId: null,
           loanId: null,
           rowKey: null,
           previousVariantId: null
         },
        loanproupload_fields_export: {
        'Action': 'action',
        'Loan ID': 'loan_id',
        'Type': 'type',
        'Collateral Position ID': 'collateralPositionId',
        'CF422': 'cf422',
        'CF423': 'cf423',
      },
      stausUrl: '',
      isCheckStatus: false,
      errorMessage: '',
      successMessage: '',
      }
      },
      computed: {
        recordRange() {
          if (this.rows === 0 || this.mmrListData.length === 0) {
            return ;
          }
          const start = (this.currentPage - 1) * this.perPage + 1;
          const end = Math.min(this.currentPage * this.perPage, this.rows);
          return `Showing ${start} to ${end} of ${this.rows} records`;
        }
      },
      methods: {
        getMmrList () {
            this.isLoading = true
            this.noResult = ''
            this.mmrListData = []
            let searchParams = new URLSearchParams()
            if(this.selectedYear) {
                searchParams.append('year',this.selectedYear)
            }
            if(this.selectedMonth) {
                searchParams.append('month',this.selectedMonth)
            }
            // Use filter values if available, otherwise use original values
            if(this.filterStartDate) {
                searchParams.append('startDate',this.filterStartDate)
            } 
            if(this.filterEndDate) {
                searchParams.append('endDate',this.filterEndDate)
            }
            if(this.filterVin) {
                searchParams.append('vin',this.filterVin)
            }
            if(this.filterLoanId) {
                searchParams.append('loanId',this.filterLoanId)
            }
            if(this.mmrListSearch) {
                searchParams.append('search',this.mmrListSearch)
            }
            if(this.filterReportType) {
                searchParams.append('reportType',this.filterReportType)
            }
             httpcommon.get(`/mmr-llp/loans/vin-details?${searchParams.toString()}&page=${this.currentPage-1}&size=${this.perPage}`).then(response=>{
                this.isLoading = false
                this.getDataDateRange()
                if(response && response.data.data) {
                    this.mmrListData = response.data.data
                    this.rows = response.data.totalRecords
                } else {
                    console.log(response,'response.data.data')
                    this.noResult = response.data.message
                }   
            }).catch(error=>{
                this.isLoading = false
                console.log(error)
            })
        },
        pagination () {
          this.getMmrList()
        },
        
        clearMmrListSearch() {
          this.mmrListSearch = '';
          if(this.isMmrListSearch) {
            this.isMmrListSearch = false
            this.currentPage = 1
            this.perPage = 10
            this.getMmrList()
          }
        },
        searchMmrList() {
          if(this.mmrListSearch) {
            this.isMmrListSearch = true
            this.currentPage = 1
            this.perPage = 10
            this.getMmrList()
          } else {
            this.isMmrListSearch = false
          }
        },
       
        isActiveRoute(route) {
          return this.$route.path === route;
        },
        retrieveData: function () {
          httpcommon
            .get("/userrole/")
            .then((response) => {
              this.userroles = response.data;
            })
            .catch((e) => {
              console.log(e);
              this.errorslist.push(e);
            });
          httpcommon
            .get("/staticdata/status/")
            .then((response) => {
              this.status = response.data;
            })
            .catch((e) => {
              this.errorslist.push(e);
            });
        },
        myFunction() {
          var elmnt = document.getElementById("height2");
          var elmnt1 = document.getElementById("height3");
          var txt = elmnt.offsetHeight;
          var width = elmnt.offsetWidth;
          var txt1 = elmnt1.offsetHeight;
          var ht = txt + txt1;
          $("#employee").css("margin-top", txt + txt1 + 3);
        },
        menuheight () {
          var elmnt = document.getElementById("height2");
          var txt = elmnt.offsetHeight;
          $('#height3').css('margin-top', txt)
        },
        openExportDrawer(vinNumber) {
          this.selectedVinNumber = vinNumber
          this.selectedYearForVinDetail = ''
          this.selectedMonthForVinDetail = ''
          this.singleVinMmrData = []
          
          this.getMmrDetailByVin(vinNumber)
        },
        closeExportDrawer() {
          this.isDrawerOpen = false;
          // Restore body scroll when drawer is closed
          document.body.style.overflow = '';
          // Reset selected year when drawer closes (handles backdrop click, ESC key, etc.)
          this.selectedMonthForVinDetail = '';
          this.selectedYearForVinDetail = '';
        },
        onExportTypeChange(type) {
        //   const selectedType = this.exportType;
        const selectedType = type;
          // Reset exportType to empty so the same option can be selected again
          this.$nextTick(() => {
            this.exportType = '';
          });
          
          if (selectedType === 'type1') {
            this.DownloadLoanProUploadCSV();
          } else if (selectedType === 'type2' || selectedType === 'type3') {
            this.getMmrReport(selectedType);
          }
        },
        DownloadLoanProUploadCSV() {
          this.isLoading = true
          let params = new URLSearchParams()
          params.append('year',this.selectedYear)
          params.append('month',this.selectedMonth)
          if(this.filterReportType) {
            params.append('reportType',this.filterReportType)
          }

          // Try to get CSV as blob first
          const responseType = 'blob'
          httpcommon.get(`/mmr-llp/loanpro-upload?${params.toString()}`, {
            responseType: 'blob'
          }).then( async response=>{
            this.isLoading = false
            const contentType = response.headers['content-type'] || response.headers['Content-Type'] || ''
            // this.exportSuccess = 'LoanPro Upload File exported successfully'
            // Check if response is already a CSV blob
            // console.log(response.data,'response.data.message')
            if (responseType === 'blob' && contentType.includes('application/json')) {
              // Server returned JSON error instead of CSV - convert blob to text and parse
              try {
                const text = await response.data.text()
                const jsonData = JSON.parse(text)
                if (jsonData.message) {
                  console.log(jsonData.message, 'response.data.message1')
                  // You might want to show an error message to the user here
                  this.isExportSuccess = true
                  this.exportError = jsonData.message
                  setTimeout(()=>{
                    this.isExportSuccess = false
                    this.exportError = ''
                  },2000)
                }
              } catch (parseError) {
                console.error('Error parsing JSON from blob:', parseError)
              }
            } else if (responseType === 'blob') {
            if (response.data instanceof Blob) {
                this.isExportSuccess = true
                this.exportSuccess = 'LoanPro Upload File exported successfully'
                setTimeout(()=>{
                  this.isExportSuccess = false
                  this.exportSuccess = ''
                },2000)
              this.downloadBlobAsCSV(response.data, 'LoanPro_Upload' );
            } 
          } else {
            // Handle JSON response
            if (response.data && response.data.message) {
              console.log(response.data.message, 'response.data.message2')
              // You might want to show an error message to the user here
            }
          }
          })
          .catch(error=>{
            console.log(error,'error')
            this.isLoading = false
          });
        },
        getMmrReport(type) {
            let params = new URLSearchParams()
            if(type === 'type2') {
                const currentYear = new Date().getFullYear()
                const currentMonth = this.months[new Date().getMonth()].value
                params.append('year',currentYear)
                params.append('month',currentMonth)
                if(this.filterReportType) {
                    params.append('reportType',this.filterReportType)
                }
            } else if(type === 'type3') {
                if(this.selectedYear) {
                    params.append('year',this.selectedYear)
                }
                if(this.selectedMonth) {
                    params.append('month',this.selectedMonth)
                }
                if(this.filterVin) {
                    params.append('vin',this.filterVin)
                }
                if(this.filterLoanId) {
                    params.append('loanId',this.filterLoanId)
                }
                if(this.filterStartDate) {
                    params.append('startDate',this.filterStartDate)
                }
                if(this.filterEndDate) {
                    params.append('endDate',this.filterEndDate)
                }
                if(this.filterReportType) {
                    params.append('reportType',this.filterReportType)
                }
            }
          this.exportMmrReport(params, type)
        },
        exportHistoricalVinData() {
            if(!this.exportStartDate || !this.exportEndDate) {
                // You might want to show an error message here
                return;
            }
            let params = new URLSearchParams()
            params.append('startDate', this.exportStartDate)
            params.append('endDate', this.exportEndDate)
            if(this.filterVin) {
                params.append('vin', this.filterVin)
            }
            if(this.filterLoanId) {
                params.append('loanId', this.filterLoanId)
            }
            if(this.filterReportType) {
                params.append('reportType', this.filterReportType)
            }
            this.exportMmrReport(params, 'type3')
            // Reset after export
            this.cancelHistoricalExport()
        },
        cancelHistoricalExport() {
            this.showHistoricalExportDateRange = false
            this.exportStartDate = ''
            this.exportEndDate = ''
        },

        exportMmrReport(params, type) {
          this.isLoading = true
          // Try to get CSV as blob first
          const responseType = 'blob'
          httpcommon.get(`/mmr-llp/mmr-report?${params.toString()}`, {
            responseType: 'blob',
          }).then(async response=>{
            this.isLoading = false
            
            // Check content type from response headers
            const contentType = response.headers['content-type'] || response.headers['Content-Type'] || ''
            
            // If response type is blob, check if server actually returned JSON (error response)
            if (responseType === 'blob' && contentType.includes('application/json')) {
              // Server returned JSON error instead of CSV - convert blob to text and parse
              try {
                const text = await response.data.text()
                const jsonData = JSON.parse(text)
                if (jsonData.message) {
                  console.log(jsonData.message, 'response.data.message1')
                  // You might want to show an error message to the user here
                  this.isExportSuccess = true
                  this.exportError = jsonData.message
                  setTimeout(()=>{
                    this.isExportSuccess = false
                    this.exportError = ''
                  },2000)
                }
              } catch (parseError) {
                console.error('Error parsing JSON from blob:', parseError)
              }
            } else if (responseType === 'blob') {
              // Handle blob response (CSV file)
              if (response.data instanceof Blob) {
                this.isExportSuccess = true
                this.exportSuccess = type == 'type2' ? 'Current Month MMR Report exported successfully' : 'Historical VIN Data exported successfully'
                setTimeout(()=>{
                  this.isExportSuccess = false
                  this.exportSuccess = ''
                },2000)
                this.downloadBlobAsCSV(response.data, 'Mmr_Report' );
              }
            } else {
              // Handle JSON response
              if (response.data && response.data.message) {
                console.log(response.data.message, 'response.data.message2')
                // You might want to show an error message to the user here
              }
            }
          })
          .catch(error=>{
            console.log(error,'error')
            this.isLoading = false
            // Handle error - might want to show error message to user
          });
        },
        getMmrReportForVinDetail(vinNumber, type) {
          let params = new URLSearchParams()
          params.append('vin',vinNumber)
          if(this.selectedYearForVinDetail) {
            params.append('year',this.selectedYearForVinDetail)
          }
          if(this.selectedMonthForVinDetail) {
            params.append('month',this.selectedMonthForVinDetail)
          }
          if(this.filterReportType) {
            params.append('reportType', this.filterReportType)
          }
          this.closeExportDrawer()
          this.exportMmrReport(params, type)
        },
        downloadBlobAsCSV(blob, fileNametxt) {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          const fileName = fileNametxt + '_' + moment(new Date()).format('MM-DD-YYYY') + '_' + this.filterReportType + '.csv';
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          window.URL.revokeObjectURL(url);
        },
        handleKeyDown(event) {
          // Close drawer on ESC key
          if (event.key === 'Escape' && this.isDrawerOpen) {
            this.closeExportDrawer();
          }
        },
        closeFilterMenu() {
          // Close the filter dropdown
          if (this.$refs.filterDropdown) {
            this.$refs.filterDropdown.hide();
          }
        },
        resetFilter() {
          // Reset all filter values
          this.filterStartDate = '';
          this.filterEndDate = '';
          this.filterVin = '';
          this.filterLoanId = '';
          this.currentPage = 1;
          this.perPage = 10;
          this.selectedYear = new Date().getFullYear();
          this.selectedMonth = new Date().getMonth() + 1;
          this.filterReportType = '';
          // Optionally refresh the data
          this.getMmrList();
          // Close the dropdown
          this.closeFilterMenu();
        },
        applyFilter() {
          // Apply filters and refresh data
          this.currentPage = 1;
          this.size = 10;
          this.getMmrList();
          // Close the dropdown
          this.closeFilterMenu();
        },
        getMmrDetailByVin (vinNumber) {
            this.isLoading = true
            let searchParams = new URLSearchParams()
            searchParams.append('vin',vinNumber)
            searchParams.append('page',0)
            searchParams.append('size',1000)
            if(this.selectedYearForVinDetail) {
                searchParams.append('year',this.selectedYearForVinDetail)
            }
            if(this.selectedMonthForVinDetail) {
                searchParams.append('month',this.selectedMonthForVinDetail)
            }
            
             httpcommon.get(`/mmr-llp/loans/vin-details?${searchParams.toString()}`).then(response=>{
                this.isLoading = false
                this.isDrawerOpen = true;
                // Prevent body scroll when drawer is open
                document.body.style.overflow = 'hidden';
                if(response.data.data) {
                this.singleVinMmrData = response.data.data
                } else {
                    this.singleVinMmrData = []
                    this.noResult = response.data.message
                }
                
            }).catch(error=>{
                this.isLoading = false
                this.singleVinMmrData = []
                console.log(error)
            })
        },
        customDateChange() {
          this.selectedYear = ''
          this.selectedMonth = ''
        },
        onYearMonthChange() {
          this.filterStartDate = ''
          this.filterEndDate = ''
        //   this.getMmrList();
        },
        onDrawerYearMonthChange(vinNumber) {
          this.getMmrDetailByVin(vinNumber)
        },
        formateRequestedDate(date) {
           return new Date(date).toLocaleDateString('en-US', { year: 'numeric', month: 'long' })
        },
        getDataDateRange() {
          if(this.selectedYear && this.selectedMonth) {
           return this.dataDateRange = this.months.find(month => month.value === this.selectedMonth).month + ' ' + this.selectedYear
          } else if(this.filterStartDate && this.filterEndDate) {
            return this.dataDateRange = moment(this.filterStartDate).format('MMM D, YYYY') + ' to ' + moment(this.filterEndDate).format('MMM D, YYYY')
          } else if(this.filterStartDate && !this.filterEndDate) {
            return this.dataDateRange = moment(this.filterStartDate).format('MMM D, YYYY') + ' to ' + moment(new Date()).format('MMM D, YYYY')
          } else if(!this.filterStartDate && this.filterEndDate) {
            return this.dataDateRange = 'to ' + this.filterEndDate
          }
        },
        getVinList() {
          httpcommon.get('/mmr-llp/vin-list').then(response=>{
            console.log(response.data.data,'vinOptions')
            this.vinOptions = response.data
          }).catch(error=>{
            console.log(error,'error')
          })
        },
        getActiveLoanIds() {
          httpcommon.get('/mmr-llp/active-loan-ids').then(response=>{
            console.log(response.data.data,'loanIdOptions')
            this.loanIdOptions = response.data
          }).catch(error=>{
            console.log(error,'error')
          })
        },
        formatNumberInternational (number) {
        // Use built-in function toLocaleString for international formatting
        return '$' + parseFloat(number).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
        getRowKey(mmr, index) {
          // Use a combination of loanId and index to create a unique key
          return mmr.loanId ? `${mmr.loanId}-${index}` : `row-${index}`;
        },
        isRowExpanded(rowKey) {
          return this.expandedRows.includes(rowKey);
        },
        toggleRowExpansion(rowKey, mmr) {
          const index = this.expandedRows.indexOf(rowKey);
          if (index > -1) {
            this.expandedRows.splice(index, 1);
            return;
          } else {
            this.expandedRows.push(rowKey);
          }
          const alreadyLoaded = this.multiVariantData[rowKey] && this.multiVariantData[rowKey].length;
          if (!alreadyLoaded) {
            this.fetchMultiVariantData(rowKey, mmr);
          }
        },
        handleExpandedAction(mmr, rowKey) {
          // Handle the button click action
          const selectedOption = this.selectedRadioOption[rowKey] || 'No option selected';
          console.log('Action clicked for loan:', mmr.loanId, 'Selected option:', selectedOption);
          // Add your custom logic here
        },
        fetchMultiVariantData(rowKey, mmr) {
          const searchParams = new URLSearchParams();
          searchParams.append('vin', mmr.vin);
          searchParams.append('requestedDate', mmr.requestedDate);
          httpcommon
            .get(`/mmr-llp/vin-variants?${searchParams.toString()}`)
            .then(response => {
              const variants = Array.isArray(response.data) ? response.data : [];
              this.$set(this.multiVariantData, rowKey, variants);
              const preselected = variants.find(variant => variant.correctVariant || variant.isCorrect);
              if (preselected) {
                this.$set(this.selectedVariant, rowKey, preselected.id);
              }
            })
            .catch(error => {
              console.log(error, 'error');
              this.$set(this.multiVariantData, rowKey, []);
            });
        },
        showVariantConfirmModal(variantId, loanId, rowKey, variant, event) {
          // Prevent default radio button selection
          if (event) {
            event.preventDefault();
            event.stopPropagation();
          }
          
          // Store the previous selection in case user cancels
          const previousVariantId = this.selectedVariant[rowKey] || null;
          
          // Don't proceed if clicking the already selected radio
          if (previousVariantId === variantId) {
            return;
          }
          
          // Store pending selection
          this.pendingVariantSelection = {
            variantId: variantId,
            loanId: loanId,
            rowKey: rowKey,
            previousVariantId: previousVariantId
          };
          
          // Show confirmation modal
          this.isVariantConfirm = true;
        },
        confirmVariantSelection() {
          // Close modal
          this.isVariantConfirm = false;
          
          // Now update the selection and call the API
          const { variantId, loanId, rowKey } = this.pendingVariantSelection;
          this.$set(this.selectedVariant, rowKey, variantId);
          this.markCorrectVinVariant(variantId, loanId, rowKey);
          
          // Clear pending selection
          this.pendingVariantSelection = {
            variantId: null,
            loanId: null,
            rowKey: null,
            previousVariantId: null
          };
        },
        cancelVariantSelection() {
          // Close modal
          this.isVariantConfirm = false;
          
          // Reset radio button to previous state (empty if no previous selection)
          const { rowKey, previousVariantId } = this.pendingVariantSelection;
          if (rowKey) {
            // Set back to previous selection (null/empty if there was no previous selection)
            this.$set(this.selectedVariant, rowKey, previousVariantId || '');
            // Force Vue to update the DOM
            this.$forceUpdate();
          }
          
          // Clear pending selection
          this.pendingVariantSelection = {
            variantId: null,
            loanId: null,
            rowKey: null,
            previousVariantId: null
          };
        },
        markCorrectVinVariant(variantId, loanId, rowKey) {
          // Store previous selection before making API call for error handling
          const previousVariantId = this.selectedVariant[rowKey] || null;
          
          this.isLoading = true
          this.$set(this.selectedVariant, rowKey, variantId)
          let searchParams = new URLSearchParams()
          searchParams.append('id',variantId)
          searchParams.append('loanId',loanId)
          httpcommon.put(`/mmr-llp/mark-correct-vin-variant?${searchParams.toString()}`).then(response=>{
            this.isLoading = false
            this.isExportSuccess = true
            this.exportSuccess = response.data.message
            setTimeout(()=>{
              this.isExportSuccess = false
              this.exportSuccess = ''
            },2000)
            this.getMmrList()
          }).catch(error=>{
            // Reset to previous selection on error
            this.$set(this.selectedVariant, rowKey, previousVariantId || '')
            this.isLoading = false
            this.isExportSuccess = true
            this.exportError = (error.response && error.response.data && error.response.data.message) || error.message || 'An error occurred'
            setTimeout(()=>{
              this.isExportSuccess = false
              this.exportError = ''
            },2000)
          })
        },
        executeScript() {
          this.isLoading = true
          this.errorMessage = ''
          httpcommon.post('vendor/api/v1/sync-collateral-and-mmr').then(response=>{
            this.isLoading = false
            this.isCheckStatus = true
            this.stausUrl = response.data.statusUrl
            sessionStorage.setItem('statusUrl', response.data.statusUrl)
          }).catch(error=>{
            this.isLoading = false
            console.log(error,'error')
            this.errorMessage = (error.response && error.response.data && error.response.data.message) || error.message || 'An error occurred'
            setTimeout(()=>{
              this.errorMessage = ''
            },2000)
          })
        },
        checkStatus() {
          this.isLoading = true
          httpcommon.get(this.stausUrl).then(response=>{
            this.isLoading = false
            if(response.data.status === 'RUNNING' || response.data.status === 'COMPLETED') {
            this.successMessage = response.data.status
            } else {
              this.errorMessage = response.data.status
            }
            if(response.data.status === 'COMPLETED' || response.data.status === 'FAILED') {
              this.isCheckStatus = false
              this.stausUrl = ''
              sessionStorage.removeItem('statusUrl')
              this.getMmrList()
            }
          }).catch(error=>{
            this.isLoading = false
            this.errorMessage = (error.response && error.response.data && error.response.data.message) || error.message || 'An error occurred'
            sessionStorage.removeItem('statusUrl')
            this.isCheckStatus = false
            this.stausUrl = ''
          })
          setTimeout(()=>{
            this.errorMessage = ''
            this.successMessage = ''
          },5000)
        }
      },
      beforeDestroy() {
        // Clean up: restore body scroll if component is destroyed while drawer is open
        if (this.isDrawerOpen) {
          document.body.style.overflow = '';
        }
        // Remove event listeners
        document.removeEventListener('keydown', this.handleKeyDown);
      },
      created () {
        window.addEventListener('resize', this.myFunction)
        window.addEventListener('resize', this.menuheight)
        // Add ESC key listener for drawer
        document.addEventListener('keydown', this.handleKeyDown)
      },
      mounted () {
        if(sessionStorage.getItem('statusUrl') ) {
          this.isCheckStatus = true
          this.stausUrl = sessionStorage.getItem('statusUrl')
        }
        const currentYear = new Date().getFullYear();
        for(let i = currentYear; i >= currentYear - 7; i--) {
          this.years.push(i);
        }
        this.myFunction()
        this.menuheight()
        this.getMmrList()
        this.getVinList()
        this.getActiveLoanIds()
      },
    }
</script>
<style scoped>
    .customerTable {
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      /* line-height: 32px; */
      table-layout: auto;
      width: 100%;
    }
    .customerTable thead tr {
      color: #000000;
      background: #E1E4E7;
      font: 600 12px 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      /* line-height: 32px; */
    }
    .customerTable thead tr th {
        border-top: none;
        white-space: nowrap;
    }
    .customerTable tbody tr td {
      font-size: 14px;
      font-weight: 600;
      color: #2C2C2C;
      white-space: nowrap;
    }
    tbody tr {
      border-bottom: 1px solid #dbdbdb;
    }
    .mergeStatus {
        color: #00AA00 !important;
    }
    .unMergeStatus {
        color: #F22A0E !important;
    }
    .loader-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.8);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999;
    }
    .loader {
      border: 12px solid #f3f3f3;
      border-top: 12px solid #3498db;
      border-radius: 50%;
      width: 60px;
      height: 60px;
      animation: spin 2s linear infinite;
    }
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    .customPagination ::v-deep .page-link {
      display: flex;
      align-items: center;
      justify-content: center;
      border: none ;
      height: 30px;
      width: 30px;
      margin: 0;
      padding: 10px;
      font-size: 20px;
      color: #9B9B9B;
      margin-left: 10px;
    }
    .customPagination ::v-deep .active .page-link {
      background-color: #005DF1;
      border-radius: 8px;
      color: #FFFFFF;
      margin-left: 10px;
    }
    .pagination.customPagination ::v-deep .page-item:first-child .page-link,
    .pagination.customPagination ::v-deep .page-item:last-child .page-link {
      font-size: 40px !important; /* Adjust the font size as needed */
      padding: 0 20px 10px 20px;
    }
    .navLinks {
        list-style: none;
        display: flex;
        padding-left: 0;
        justify-content: center;
    }
    .navLinks li {
        padding: 10px 35px 10px 0px;
    }
    .linkItem {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-size: 18px;
    font-weight: 600;
    color: #8C8C8C;
    Padding:10px 30px 10px 30px;
    border-radius: 8px;
    }
    .linkItem:hover {
        color: #FFFFFF;
        background-color: #1E90FF;
    }
    .navLinks .active {
    color: #FFFFFF !important;
    background-color: #1E90FF;
    }
    .activitySearch input, .activitySearch select {
      font: 400;
      font-size: 16px;
      color: #1C1B1F;
      border: 1px solid #E4ECF4;
      border-radius: 8px;
      padding: 10px;
      height: 44px !important;
      width: 100%;
    }

    .search-input-wrapper {
      position: relative;
      width: 100%;
    }

    .search-input {
      padding-right: 40px !important;
    }

    .clear-search-btn {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      background: none;
      border: none;
      cursor: pointer;
      padding: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #666;
      transition: color 0.2s;
      z-index: 10;
    }

    .clear-search-btn:hover {
      color: #000;
    }

    .clear-search-btn svg {
      width: 16px;
      height: 16px;
    }
    .activityBtn button {
      border-radius: 8px;
      color: #FFFFFF;
      font-weight: 600;
      font-size: 18px;
      background-color: #1E90FF;
      padding: 10px;
      height: 44px;
      width: 160px;
      border: none;
      width: 100%;
    }
    /* MMR Export Drawer Styles */
    .mmrExportDrawerWrapper {
      position: relative;
    }

    .drawer-backdrop {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 1040;
      transition: opacity 0.3s ease;
    }

    .mmrExportDrawer {
      position: fixed;
      top: 0;
      right: 0;
      width: 100%;
      max-width: 500px;
      height: 100%;
      background-color: #ffffff;
      box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
      z-index: 1041;
      transform: translateX(100%);
      transition: transform 0.3s ease;
      overflow-y: auto;
      display: flex;
      flex-direction: column;
    }

    .mmrExportDrawer.drawer-open {
      transform: translateX(0);
    }

    .drawer-header {
      padding: 20px;
      border-bottom: 1px solid #e0e0e0;
      background-color: #ffffff;
      position: sticky;
      top: 0;
      z-index: 10;
    }

    .drawer-header h2 {
      margin: 0;
      font-size: 24px;
      font-weight: 600;
      color: #000000;
    }

    .drawer-header button {
      font-size: 24px;
      color: #666;
      background: none;
      border: none;
      cursor: pointer;
      padding: 0;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: color 0.2s;
    }

    .drawer-header button:hover {
      color: #000;
    }

    .vehicleInfo {
      padding: 20px;
      border-bottom: 1px solid #e0e0e0;
    }

    .headerData {
      margin-bottom: 20px;
    }

    .leftData h3 {
      margin: 0 0 10px 0;
      font-size: 20px;
      font-weight: 600;
      color: #000000;
    }

    .metaInfoFlexItem {
      margin-top: 10px;
    }

    .metaInfoFlexItem p {
      margin: 0;
      font-size: 14px;
      color: #666;
    }

    .metaInfoFlexItem p strong {
      color: #000;
      font-weight: 600;
    }

    .rightData {
      display: flex;
      align-items: center;
    }

    /* .exportBtn {
      background: none;
      border: none;
      cursor: pointer;
      padding: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background-color 0.2s;
      border-radius: 4px;
    }

    .exportBtn:hover {
      background-color: #f5f5f5;
    } */
     .exportBtn {
        background-color: #1E90FF;
        color: #ffffff;
        border: none;
        border-radius: 8px;
        padding: 10px;
        height: 44px;
        margin-right: 10px;
        /* width: 100%; */
     }
     .exportBtn.cancelBtn {
        background-color: #6c757d;
     }
     .exportBtn.cancelBtn:hover {
        background-color: #5a6268;
     }
     .historical-export-date-range {
        flex-wrap: wrap;
     }
     .historical-export-date-range .date-input-wrapper {
        min-width: 150px;
     }
     .historical-export-date-range input[type="date"] {
        padding: 10px;
        border: 1px solid #E4ECF4;
        border-radius: 8px;
        font-size: 16px;
        height: 44px;
        width: 100%;
     }

    .exportCalendar {
      margin-top: 20px;
    }

    .commonFomrWrapper {
      width: 100%;
    }

    .form-group {
      margin-bottom: 20px;
    }

    .form-label {
      display: block;
      margin-bottom: 8px;
      font-size: 14px;
      font-weight: 500;
      color: #333;
    }

    .form-control {
      padding: 10px;
      border: 1px solid #e0e0e0;
      border-radius: 4px;
      font-size: 14px;
      width: 100%;
    }

    .dateRangeBox {
      width: 100%;
    }

    .date-input-wrapper {
      display: flex;
      flex-direction: column;
    }

    .or-divider {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 15px 0;
      position: relative;
    }

    .or-divider::before,
    .or-divider::after {
      content: '';
      flex: 1;
      height: 1px;
      background-color: #e0e0e0;
    }

    .or-text {
      padding: 0 15px;
      color: #666;
      font-size: 14px;
      font-weight: 500;
      background-color: #ffffff;
    }

    .yearMonthBox {
      width: 100%;
    }

    .select-wrapper {
      display: flex;
      flex-direction: column;
    }

    .selectBox {
      width: 100%;
    }

    input[type="date"] {
      width: 100%;
      padding: 10px;
      border: 1px solid #e0e0e0;
      border-radius: 4px;
      font-size: 14px;
      color: #333;
    }

    input[type="date"]:focus {
      outline: none;
      border-color: #005DF1;
      box-shadow: 0 0 0 0.2rem rgba(0, 93, 241, 0.25);
    }

    .drawer-content {
      flex: 1;
      padding: 20px;
      overflow-y: auto;
    }

    .timeline {
      width: 100%;
    }

    .timelineItems {
      position: relative;
      padding-left: 30px;
    }

    .timelineItem {
      position: relative;
      padding-bottom: 30px;
      padding-left: 30px;
    }

    .timelineItem:last-child {
      padding-bottom: 0;
    }

    .timelineMarker {
      position: absolute;
      left: -8px;
      top: 0;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background-color: #005DF1;
      border: 3px solid #ffffff;
      box-shadow: 0 0 0 2px #005DF1;
    }

    .timelineItem::before {
      content: '';
      position: absolute;
      left: -2px;
      top: 16px;
      bottom: -10px;
      width: 2px;
      background-color: #e0e0e0;
    }

    .timelineItem:last-child::before {
      display: none;
    }

    .timelineContent {
      background-color: #f9f9f9;
      padding: 15px;
      border-radius: 8px;
      border-left: 3px solid #005DF1;
    }

    .timelineHeader {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 10px;
    }

    .timelineDate {
      font-size: 14px;
      font-weight: 600;
      color: #333;
      line-height: 1.2;
    }

    .timelineValueWrapper {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 4px;
      line-height: 1.2;
    }

    .timelineValueLabel {
      font-size: 12px;
      font-weight: 500;
      color: #666;
      /* text-transform: uppercase; */
      letter-spacing: 0.5px;
    }

    .timelineValue {
      font-size: 16px;
      font-weight: 700;
      color: #005DF1;
    }

    .timelineDescription {
      margin: 0;
      font-size: 14px;
      color: #666;
      line-height: 1.5;
    }

    .gap-4 {
      gap: 1rem;
    }

    @media (max-width: 768px) {
      .mmrExportDrawer {
        max-width: 100%;
      }
    }

    /* Filter Button & Dropdown Styles */
    .tableFilterAction {
      display: flex;
      align-items: center;
    }

    .filter-btn-dropdown {
      width: 100%;
      height: 44px;
    }

    .filter-btn-dropdown ::v-deep .btn {
      width: 100%;
      height: 44px;
      border: 1px solid #E4ECF4;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      background-color: #1E90FF;
      color: #ffffff;
      font-weight: 400;
      transition: all 0.2s;
    }

    .filter-btn-dropdown ::v-deep .btn::after {
          display: none;
    }

    .filter-btn-dropdown ::v-deep .btn:hover,
    .filter-btn-dropdown ::v-deep .btn:focus,
    .filter-btn-dropdown ::v-deep .btn:not(:disabled):not(.disabled):active {
      /* background-color: #f5f5f5; */
      /* border-color: #E4ECF4; */
      /* color: #1C1B1F; */
      box-shadow: none;
    }

    .filter-btn-dropdown ::v-deep .dropdown-menu {
      min-width: 400px;
      max-width: 500px;
      padding: 0;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      margin-top: 8px;
    }

    .comm-dropdown.filterMenuOuter {
      padding: 0;
    }

    .form-wrap {
      padding: 20px;
    }

    .filter-header {
      margin-bottom: 20px;
      padding-bottom: 15px;
      border-bottom: 1px solid #e0e0e0;
    }

    .filter-header h3 {
      margin: 0;
      font-size: 18px;
      font-weight: 600;
      color: #000000;
    }

    .close-btn {
      /* width: 32px;
      height: 32px; */
      display: flex;
      align-items: center;
      justify-content: center;
      color: #666;
      border: none;
      background: none;
      cursor: pointer;
      padding: 0;
      transition: color 0.2s;
    }

    .close-btn:hover {
      color: #000;
      background-color: #f5f5f5;
      border-radius: 4px;
    }

    .close-btn svg {
      width: 20px;
      height: 20px;
    }

    .form-row {
      margin-bottom: 20px;
    }

    .inputBox {
      width: 100%;
    }

    .selectBox {
      width: 100%;
    }

    .form-label {
      display: block;
      margin-bottom: 8px;
      font-size: 14px;
      font-weight: 500;
      color: #333;
    }

    .primary-radio {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .primary-radio .form-check {
      display: flex;
      align-items: center;
      margin: 0;
    }

    .primary-radio .form-check-input {
      margin-top: 0;
      margin-right: 8px;
      width: 18px;
      height: 18px;
      cursor: pointer;
    }

    .primary-radio .form-check-label {
      font-size: 14px;
      color: #333;
      cursor: pointer;
      margin: 0;
    }

    .primary-radio .form-check-input:checked {
      background-color: #1E90FF;
      /* border-color: #005DF1; */
      border-color: #1E90FF;
    }

    .primary-radio .form-check-input:focus {
      box-shadow: 0 0 0 0.2rem rgba(0, 93, 241, 0.25);
      border-color: #005DF1;
    }

    .filterBtnHolder {
      display: flex;
      justify-content: flex-end;
      gap: 12px;
      margin-top: 20px;
      padding-top: 20px;
      border-top: 1px solid #e0e0e0;
    }

    .filterBtnHolder .btn {
      min-width: 100px;
      padding: 10px 20px;
      font-size: 14px;
      font-weight: 500;
      border-radius: 4px;
    }

    .filterBtnHolder .btn-outline-primary {
      border-color: #1E90FF;
      color: #1E90FF;
      background-color: #ffffff;
    }

    .filterBtnHolder .btn-outline-primary:hover {
      /* background-color: #005DF1; */
      background-color: #1E90FF;
      color: #ffffff;
    }

    .filterBtnHolder .btn-primary {
      background-color: #1E90FF;
      border-color: #1E90FF;
      color: #ffffff;
    }

    .filterBtnHolder .btn-primary:hover {
      background-color: #1E90FF;
      border-color: #0047c4;
    }

    .mb-20 {
      margin-bottom: 20px;
    }

    .flex-grow-1 {
      flex-grow: 1;
    }
    .disabled-btn {
      cursor: default;
    }
    .data-availability-text {
      font-size: 13px;
      color: #1E90FF;
      font-weight: 600;
    }
    .total-records-text {
      font-size: 14px;
      color: #2C2C2C;
      font-weight: 400;
    }
    .expand-arrow {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      transition: transform 0.3s ease;
      color: #1E90FF;
    }
    .expand-arrow.expanded {
      transform: rotate(90deg);
    }
    .expanded-row {
      background-color: #f9f9f9;
    }
    .expanded-content {
      padding: 20px !important;
      background-color: #f9f9f9;
    }
    .expanded-content-wrapper {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }
    .expanded-table-container {
      width: fit-content;
      overflow-x: auto;
    }
    .expanded-table {
      width: 100%;
      background-color: #ffffff;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      overflow: hidden;
    }
    .expanded-table thead {
      background-color: #E1E4E7;
    }
    .expanded-table thead th {
      padding: 12px;
      font-weight: 600;
      font-size: 12px;
      color: #000000;
      border-bottom: 1px solid #dbdbdb;
    }
    .expanded-table tbody td {
      padding: 12px;
      font-size: 14px;
      color: #2C2C2C;
      border-bottom: 1px solid #dbdbdb;
    }
    .expanded-table tbody tr:last-child td {
      border-bottom: none;
    }
    .expanded-controls {
      display: flex;
      /* justify-content: space-between; */
      align-items: center;
      gap: 20px;
      flex-wrap: wrap;
    }
    .radio-buttons-group {
      display: flex;
      gap: 20px;
      flex-wrap: wrap;
    }
    .radio-buttons-group .form-check {
      display: flex;
      align-items: center;
      margin: 0;
    }
    .radio-buttons-group .form-check-input {
      margin-top: 0;
      margin-right: 8px;
      width: 18px;
      height: 18px;
      cursor: pointer;
    }
    .radio-buttons-group .form-check-label {
      font-size: 14px;
      color: #333;
      cursor: pointer;
      margin: 0;
    }
    .radio-buttons-group .form-check-input:checked {
      background-color: #1E90FF;
      border-color: #1E90FF;
    }
    .expanded-action-btn {
      background-color: #1E90FF;
      color: #ffffff;
      border: none;
      border-radius: 8px;
      padding: 10px 20px;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      transition: background-color 0.2s;
    }
    .expanded-action-btn:hover {
      background-color: #005DF1;
    }
    .modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 2;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.modal-heading {
  font-size: 14px;
}
.modal-heading::after {
  content:' ';
  height: 1px;
  background: #9B9B9B;
  width: 100%;
  display: block
}
.modal-content {
  border: #ffffff;
  background-color: #ffffff;
  padding: 36px 40px 36px 40px !important;
  width: 70vh !important;
  height: auto !important;
  max-height: 70vh;
  border-radius: 16px;
  text-align: center;
}
.modalText {
  font-size: 18px;
  font-weight: 400;
  line-height: 26.6px;
  color: #000000;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.modal-body img {
  height:70px
}
.mergeButton, .yesButton {
  background-color: #1E90FF;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  line-height: 21.28px;
  padding: 10px 20px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
}
.yesButton {
  background-color: #6c757d;
}
.yesButton:hover {
  background-color: #5a6268;
}
.mergeButton:hover {
  background-color: #005DF1;
}

    @media (max-width: 768px) {
      .filter-btn-dropdown ::v-deep .dropdown-menu {
        min-width: 300px;
        max-width: 90vw;
      }
    }
</style>
